// FILE: /components/AdminLayout.js
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getAuth, signOut } from 'firebase/auth';
import { Home, BarChart2, Lightbulb, Users, FileText, Bot, Activity, LogOut, MessageSquare, Briefcase, Monitor, BadgePercent, TrendingUp } from 'lucide-react';
import { app } from '../utils/firebaseClient';
import StatusWidget from './StatusWidget';

// A centralized list of all navigation items for the sidebar.
const navItems = [
  { href: '/', label: 'Dashboard', icon: Home },
  { href: '/admin/analytics', label: 'Analytics', icon: BarChart2 },
  { href: '/admin/tips', label: 'AI Tips', icon: Lightbulb },
  { href: '/admin/users', label: 'Users', icon: Users },
  { href: '/admin/messages', label: 'Messages', icon: MessageSquare },
  { href: '/admin/plans', label: 'Smart Plans', icon: FileText },
  { href: '/admin/investors', label: 'Investors', icon: Briefcase },
  { href: '/admin/top-strategies', label: 'Top Strategies', icon: TrendingUp },
  { href: '/admin/strategy-logs', label: 'Strategy Logs', icon: Activity },
  { href: '/admin/monetization', label: 'Monetization', icon: Monitor },
  { href: '/admin/intel', label: 'AI Intel', icon: Bot },
  { href: '/admin/ads', label: 'Ads & Promotions', icon: BadgePercent },
];

// This component provides the consistent sidebar and header for the entire admin panel.
export default function AdminLayout({ children }) {
  const router = useRouter();
  const auth = getAuth(app);

  const handleLogout = async () => {
    await signOut(auth);
    router.push('/login');
  };

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Sidebar Navigation */}
      <aside className="w-64 bg-gray-900 text-gray-300 flex flex-col fixed h-full shadow-lg">
        <div className="p-4 border-b border-gray-700 flex items-center gap-3">
           <img src="/simpleaitrade_logo.png" alt="Logo" className="h-9 w-9" />
          <h2 className="text-xl font-bold text-white">Admin Panel</h2>
        </div>
        
        {/* --- STATUS WIDGET ADDED HERE --- */}
        <div className="p-4 border-b border-gray-700">
            <StatusWidget />
        </div>

        <nav className="flex-grow p-4 overflow-y-auto">
          <ul>
            {navItems.map((item) => (
              <li key={item.href} className="mb-2">
                <Link
                  href={item.href}
                  className={`flex items-center p-2 rounded-lg hover:bg-gray-700 transition-colors ${
                    router.pathname === item.href ? 'bg-indigo-600 text-white' : 'hover:text-white'
                  }`}
                >
                  <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                  <span className="text-sm font-medium">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-700">
           <button
            onClick={handleLogout}
            className="w-full flex items-center p-2 rounded-lg text-left text-red-400 hover:bg-red-500 hover:text-white transition-colors"
          >
            <LogOut className="w-5 h-5 mr-3" />
            <span className="text-sm font-semibold">Logout</span>
          </button>
        </div>
      </aside>
      
      {/* Main Content Area */}
      <main className="flex-1 ml-64 p-8">
        {children}
      </main>
    </div>
  );
}

